export const checkApiValidation = (api, scoreValue) => {
  return false
}

export const checkCustomValidation = (validation, scoreValue) => {
  let checkList = []
  let checkItem
  validation.forEach((item) => {
    let { type, value } = item
    scoreValue = Number(scoreValue)
    value = Number(value)
    let check = false
    if (type === 'isGreater') {
      check = scoreValue > value
      checkItem = { ...item, operator: '>' }
    } else if (type === 'isLess') {
      check = scoreValue < value
      checkItem = { ...item, operator: '<' }
    } else if (type === 'isGreaterOrEqual') {
      check = scoreValue >= value
      checkItem = { ...item, operator: '>=' }
    } else if (type === 'isLessOrEqual') {
      check = scoreValue <= value
      checkItem = { ...item, operator: '<=' }
    }
    checkList.push(check)
  })
  return checkList.includes(true) ? checkItem : false
}

export const checkValidation = (validationType, validation, scoreValue) => {
  switch (validationType) {
    case 'api':
      return checkApiValidation(validation, scoreValue)
    case 'custom':
      return checkCustomValidation(validation, scoreValue)
    default:
      return false
  }
}

export const checkIsWarning = (warningChart, name, value) => {
  if (!warningChart) return false
  let warning = warningChart[name]
  if (warning) {
    let { validationType, validation } = warning
    return checkValidation(validationType, validation, value)
  }
  return false
}
